import { Component, HostBinding, Input, OnInit } from '@angular/core';
import {
  EduContentTypeEnum,
  ResultInterface,
  SectionContentInterface,
  SectionInterface,
  SectionType,
} from '@campus/dal';
import { ContentActionInterface } from '../../services';

import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-menu.js';

// duplicate of ExtendedSectionContentInterface libs\pages\practice\src\lib\factories\providers\digital-workbook\digital-workbook.provider.interface.ts
export interface SectionContentWithScoreAndActionsInterface extends SectionContentInterface {
  actions: ContentActionInterface[];
  stars: number;
  isFinished: boolean;
  result?: ResultInterface;
}

export enum SectionThemes {
  THEORY = 'theory',
  IMAGE = 'image',
  THEORY_EXPANDABLE = 'theory-expendable',
  SCHEURBLOK = 'scheurblok',
  MEDIA = 'media',
  WORKBOOK = 'workbook',
  CLASSICAL = 'classical',
}

@Component({
  standalone: false,
  selector: 'campus-edu-content-list-section',
  templateUrl: './edu-content-list-section.component.html',
  styleUrls: ['./edu-content-list-section.component.scss'],
})
export class EduContentListSectionComponent implements OnInit {
  @HostBinding('class')
  defaultClasses = ['edu-content-list-section', 'cluster', 'cluster-space-m', 'p-b-s'];

  @HostBinding('attr.data-section-theme')
  sectionTheme: string;

  @Input() section: SectionInterface;

  sectionThemes = SectionThemes;

  readonly SectionType = SectionType;
  readonly EduContentTypeEnum = EduContentTypeEnum;

  public ngOnInit(): void {
    if (this.section?.config?.theme) {
      this.sectionTheme = this.section.config.theme;
    }
  }

  public onEduContentClick(
    sectionContent: SectionContentWithScoreAndActionsInterface,
    options?: { action?: ContentActionInterface; source?: string }
  ): void {
    if (!sectionContent.actions.length) return;
    if (options?.source === 'button' && sectionContent.actions.length > 1) return;

    const { handler } = options?.action ?? sectionContent.actions[0];

    handler(sectionContent.eduContent);
  }
}
